import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORMS_CONFIG } from "../domain";
import { ACTION_GET_FORMS_CONFIGS } from "../GetFormConfigs/useGetFormConfigs";

import { formsConfigApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_FORM_CONFIG = "CREATE_FORM_CONFIG";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const deleteFormConfig = async (formId: string): Promise<void> => {
  const response =
    await formsConfigApi.formsConfigControllerDeleteFormConfig(formId);

  return response.data;
};

export const useDeleteFormConfig = (
  user: UserProfileDto | null,
): {
  deleteFormConfig: UseMutateFunction<void, Error, string, unknown>;
  deleteFormConfigEnabled: boolean;
  isSuccessDeleteFormConfig: boolean;
  isPendingDeleteFormConfig: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORMS_CONFIG, ACTION_CREATE_FORM_CONFIG],
    mutationFn: enabled ? deleteFormConfig : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FORMS_CONFIG, ACTION_GET_FORMS_CONFIGS],
      });
    },
  });

  return {
    deleteFormConfig: mutate,
    deleteFormConfigEnabled: enabled,
    isSuccessDeleteFormConfig: isSuccess,
    isPendingDeleteFormConfig: isPending,
  };
};
